import { Layout, Row, Col, Card, Space, Form, Input, Button, Typography, notification } from 'antd';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useResetPasswordMutation } from '../../../app/api/authApiSlice';
import AppFooter from '../../../components/layout/AppFooter';
import AppLogo from '../../../components/layout/AppLogo';

const { Content } = Layout;
const { Text } = Typography;

const PasswordReset: React.FC = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId') ?? '';
  const token = searchParams.get('token') ?? '';

  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const handleResetPassword = ({ password }: any): void => {
    resetPassword({ userId, token, password })
      .unwrap()
      .then(() => {
        notification.error({
          message: 'Password reset',
          description: 'Password reset successfully. Please login with new password.',
        });
        navigate('/');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Layout style={{ background: '#f0f2f5' }}>
      <Content>
        <Row justify='center' align='middle' style={{ minHeight: '100vh' }}>
          <Col xs={20} sm={16} md={12} lg={10} xl={6} xxl={6}>
            <Card>
              <Space direction='vertical' size='middle' style={{ display: 'flex' }}>
                <Row justify='center'>
                  <AppLogo size={128} />
                </Row>
                <Row justify='center'>
                  <Text>Enter new password</Text>
                </Row>
                <Form
                  name='login'
                  initialValues={{ remember: true }}
                  onFinish={handleResetPassword}
                  autoComplete='off'
                >
                  <Form.Item
                    name='password'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                  >
                    <Input.Password placeholder='New Password' />
                  </Form.Item>
                  <Form.Item wrapperCol={{ span: 32 }}>
                    <Button type='primary' htmlType='submit' block loading={isLoading}>
                      Reset Password
                    </Button>
                    <Button
                      type='link'
                      onClick={() => navigate('/forgot-password')}
                      style={{ float: 'right' }}
                    >
                      Back to Login Page
                    </Button>
                  </Form.Item>
                </Form>
              </Space>
            </Card>
            <AppFooter />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default PasswordReset;
